import { AccessToken, RefreshToken } from "@/helper/userHelper";
import service from "../baseHttpService";

class LineService {
  DoLineSetConnect(_input: any): any {    
    const code = "?code=" + process.env.VUE_APP_PeakLineFunctionCode;
    const input:any = {
      merchantId: _input.merchantId,
      lineAccessToken: _input.accessToken,
      peakAccessToken: AccessToken(),
      peakRefreshToken: RefreshToken()
    };
    return service.peakLineFunctionAPI
      .post("/api/SetConnect" + code, input)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err
      });
  }
  DoLineAuthorize(_input: any): any {
    const code = "?code=" + process.env.VUE_APP_PeakLineFunctionCode;
    const input:any = {
      lineAccessToken: _input.accessToken,
    };
    return service.peakLineFunctionAPI
      .post("/api/Authorize" + code, input)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err
      });
  }
}

export default new LineService();
